import React, { useState } from 'react';
import { Button, Container, Image } from 'react-bootstrap';

import { AppConstants } from 'constant/index.js';
import EmpowerLearningScreens from './index.js';
import Layout from 'components/layout.js';
import Page404Screen from 'screens/404';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'components/index.js';
import { useTranslation } from 'react-i18next';
import { empowerWhite } from 'assets/icons/index.js';

const { PATH_EMPOWER_LEARNING } = AppConstants;

const EmpowerLearningScreen = () => {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const page = Number.parseInt(params.get('page') ?? 1);
  const element = EmpowerLearningScreens['page' + page];

  const [showContent, setShowContent] = useState(false);

  if (!element) {
    return <Page404Screen />;
  }
  return (
    <Layout>
      {page !== 1 &&
        (
          <div className='empower-background pt-3 pb-3'>
            <div className='d-flex flex-direction-row align-items-center justify-content-center'>
              <Image src={empowerWhite} width={24} height={24} className="text-white" />
              <h4 className='pl-2 pb-0 mb-0 text-white'>{t('learning.empower.header.1')}</h4>
            </div>
            <p className='pb-0 mb-0 text-white text-center'>{t('learning.empower.header.2')}</p>
          </div>
        )}
      <ContentModal visible={showContent} onHide={() => setShowContent(false)} t={t} />
      <div className='d-flex flex-direction-column justify-content-between p-5 pt-0 h-100'>
        <Container className='page'>
          {element}
        </Container>
        <div className='page d-flex flex-direction-row align-items-center justify-content-center mb-5'>
          <Button variant='outline-primary' disabled={page === 1} style={{ opacity: (page === 1) ? 0 : 1 }} onClick={() => window.location.href = PATH_EMPOWER_LEARNING + '?page=' + (page - 1)}>
            <div className='d-flex flex-direction-row align-items-center'>
              <FontAwesomeIcon icon={'arrow-left'} />
              <span>&nbsp;{t('previous')}</span>
            </div>
          </Button>
          <div className='px-5'>
            <Button variant='link' onClick={() => setShowContent(true)}>
              {page} / {Object.keys(EmpowerLearningScreens).length}
            </Button>
          </div>
          <Button variant='outline-primary' disabled={page === Object.keys(EmpowerLearningScreens).length} style={{ opacity: (page === Object.keys(EmpowerLearningScreens).length) ? 0 : 1 }} onClick={() => window.location.href = PATH_EMPOWER_LEARNING + '?page=' + (page + 1)}>
            <div className='d-flex flex-direction-row align-items-center'>
              <span>{t('next')}&nbsp;</span>
              <FontAwesomeIcon icon={'arrow-right'} />
            </div>
          </Button>
        </div>
      </div>
    </Layout>
  )
}

const ContentModal = ({ visible, onHide, t }) => {
  return (
    <Modal show={visible} onHide={onHide} className={'p-0'}>
      <h4 className={'px-4'}>Table of Contents</h4>
      <ul style={{ listStyle: 'none' }} className='px-4'>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=2'}>{t('learning.empower.menu.1')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=3'}>{t('learning.empower.menu.2')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=4'}>{t('learning.empower.menu.3')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=6'}>{t('learning.empower.menu.4')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=7'}>{t('learning.empower.menu.5')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=8'}>{t('learning.empower.menu.6')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=9'}>{t('learning.empower.menu.7')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=10'}>{t('learning.empower.menu.8')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=11'}>{t('learning.empower.menu.9')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=12'}>{t('learning.empower.menu.10')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=13'}>{t('learning.empower.menu.11')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=14'}>{t('learning.empower.menu.12')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=15'}>{t('learning.empower.menu.13')}</a></li>
        <li><a href={PATH_EMPOWER_LEARNING + '?page=16'}>{t('learning.empower.menu.14')}</a></li>
      </ul>
    </Modal>
  )
}

export default EmpowerLearningScreen;